// @src/components/Layout.jsx
import {  Outlet } from "react-router-dom";
const Layout = () => (
  <div style={{width: '100% !important'}}>
    <Outlet />
  </div>
);
export default Layout;